import { useEffect, useState } from 'react';

/**
 * Whether the viewport is below a breakpoint (default 768px, Tailwind's `md`).
 *
 * Drives the mobile shell: the sidebar becomes a slide-in drawer and a bottom
 * tab bar appears. Uses matchMedia rather than a resize listener so it only
 * fires on the actual breakpoint crossing, and reads the initial value
 * synchronously so there is no desktop-to-mobile flash on first paint.
 */
export function useIsMobile(breakpointPx = 768): boolean {
  const query = `(max-width: ${breakpointPx - 1}px)`;

  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    // Sync in case the breakpoint changed between render and effect.
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
